import { render, staticRenderFns } from "./FrzWeighedByPallet.vue?vue&type=template&id=5f270ba9"
import script from "./FrzWeighedByPallet.vue?vue&type=script&lang=js"
export * from "./FrzWeighedByPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports